// File: frontend/src/components/layout/PageHeader.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import styles from './PageHeader.module.css';

const PageHeader = ({ 
  title, 
  subtitle, 
  showBack = false, 
  backTo = null,
  actions = null 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={styles.pageHeader}>
      <div className={styles.headerContent}>
        {showBack && (
          <button 
            onClick={handleBack}
            className={styles.backButton}
            aria-label="Go back"
          >
            <ArrowLeft size={20} strokeWidth={2} />
          </button>
        )}
        
        <div className={styles.headerText}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>

      {actions && (
        <div className={styles.headerActions}>
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;